import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { FileEntity } from './file.entity';
import { ItemEntity } from './item.entity';

@Index('fk__file__id', ['fkFileId'], {})
@Index('item_images__fk_item_id_fk', ['fkItemId'], {})
@Index('idx_item_image_inheritedFrom', ['fkItemImageIdInheritedFrom'], {})
@Entity('item_image')
export class ItemImageEntity extends BaseEntity {
	@Column('varchar', { name: 'image_url', nullable: true, length: 255 })
	public imageUrl!: string | null;

	@Column('varchar', { name: 'image_size', nullable: true, length: 255 })
	public imageSize!: string | null;

	@Column('varchar', { name: 'labeler', nullable: true, length: 255 })
	public labeler!: string | null;

	@Column('int', { name: '_fk_item__id', unsigned: true })
	public fkItemId!: number;

	@Column('varchar', { name: 'thumbnail_url', nullable: true, length: 255 })
	public thumbnailUrl!: string | null;

	@Column('varchar', { name: 'provider', nullable: true, length: 32 })
	public provider!: string | null;

	@Column('datetime', { name: 'lastImportDate', nullable: true })
	public lastImportDate!: Date | null;

	@Column('int', { name: 'fk__file__id', nullable: true, unsigned: true })
	public fkFileId!: number | null;

	@Column('int', { name: 'sortOrder', unsigned: true, default: () => "'0'" })
	public sortOrder!: number;

	// Set when this row is an inherited copy of the parent item's image
	// (PD-16509): the parent's item_image row it mirrors. The copy shares the
	// parent's underlying file, and is removed or re-synced by the inheritance
	// service, never edited directly. NULL for the item's own images.
	@Column('int', {
		name: 'fk_item_image__id_inheritedFrom',
		nullable: true,
		unsigned: true,
	})
	public fkItemImageIdInheritedFrom!: number | null;

	@ManyToOne(() => ItemEntity, (item) => item.itemImages, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_item__id', referencedColumnName: 'id' }])
	public fkItem!: ItemEntity;

	@ManyToOne(() => FileEntity, (file) => file.itemImages, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk__file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
